






























import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({
  name: 'InputTime'
})
export default class InputTime extends Vue {
  @Prop() readonly label!: string
  @Prop({ default: false }) readonly required!: boolean
  @Prop({ default: '' }) readonly id!: string | number
  @Prop({ default: '' }) readonly name!: string
  @Prop({ default: 'md' }) readonly size!: string
  @Prop({ default: '' }) readonly className!: string
  @Prop({ default: '' }) readonly iconClass!: string
  @Prop({ default: '' }) readonly default!: string
  @Prop({ default: '' }) readonly msgError!: string
  @Prop({ default: null }) readonly hasError!: boolean | null
  @Prop({ default: null }) readonly min!: number | string | null
  @Prop({ default: null }) readonly max!: number | string | null

  value = this.default;

  onChange () {
    this.$emit('change', this.value)
  }

  input () {
    this.$emit('input', this.value)
  }

  @Watch('default', { immediate: true, deep: true })
  changeOptions (newValue: string, oldValue: string) {
    if (newValue !== oldValue) {
      this.value = this.default
      this.input()
    }
  }
}
